<div class="tab-pane fade show active" id="hotelRoomCreate" role="tabpanel" aria-labelledby="home-tab">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="content-block">
            <div class="error-list" v-if="ui.error.errors">
                <ul class="error-msg">
                    <li v-for="(error,x) in ui.error.errors" :key="x">
                        <div v-for="(err,i) in error" :key="i">
                            <p> {{err}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <form>
                <div class="form-modified">
                    <div class="row">
                        <div class="col-lg-10 offset-2">
                            <div class="informative-block">
                                <p>
                                    Add room info
                                </p>
                                <span @click="hideIcon">×</span>
                            </div>
                        </div>
                        <div class="sort-wrapper my-4">
                            <a href="javascript:void(0)" class="" @click.prevent="cancleAddRoomInfo"><i class="fas fa-arrow-circle-left"></i> Go back</a>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticTitle" class="col-sm-2 col-form-label">Enter Room Type <span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div>
                                <input type="text" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['room_type'] }" id="inputPassword" v-model="item.roomAdd.room_type" placeholder="Room type eg. single " />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'room_type'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticPhone" class="col-sm-2 col-form-label">Bed Type<span class="required">*</span></label>
                        <div class="col-sm-10">

                            <div>
                                <input type="text" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['bed_type'] }" id="inputPhone" v-model="item.roomAdd.bed_type" placeholder="bed type" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'bed_type'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticAddress" class="col-sm-2 col-form-label">Total Room<span class="required">*</span></label>
                        <div class="col-sm-10">

                            <div>
                                <input type="number" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['total_room'] }" id="inputAddress" v-model="item.roomAdd.total_room" placeholder="total this type room in your hotel" value="1" min="1" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'total_room'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Guest Adults<span class="required">*</span></label>
                        <div class="col-sm-6">

                            <div>
                                <input type="number" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['adult'] }" id="inputPassword" v-model="item.roomAdd.adult" placeholder="adult" value="1" min="1" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'adult'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Guest child<span class="required">*</span></label>
                        <div class="col-sm-6">

                            <div>
                                <input type="number" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['child'] }" id="inputPassword" v-model="item.roomAdd.child" placeholder="child" value="0" min="0" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'child'" />
                        </div>
                    </div>


                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Smoking allowed<span class="required">*</span></label>
                        <div class="col-sm-5">
                            <div>
                                <label class="customcheck">{{ item.roomAdd.is_smoking==1?'Yes':'No' }}
                                    <input type="checkbox" name="is_smoking" value="1" class="destination" v-model="item.roomAdd.is_smoking"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Free Parking<span class="required">*</span></label>
                        <div class="col-sm-5">
                            <div>
                                <label class="customcheck">{{ item.roomAdd.is_free_parking==1?'Yes':'No' }}
                                    <input type="checkbox" name="is_free_parking" value="1" class="destination" v-model="item.roomAdd.is_free_parking"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>

                    <div class="content-block">
                        <div class="row">
                            <div class="col-md-10 offset-md-2">
                                <button class="btn default-btn save-btn " type="submit " @click.prevent="saveHotelRoomInfo ">
                  {{buttonName}}
                  <spinner v-if="ui.PostLoading " :loading="ui.PostLoading "></spinner>
                </button>
                                <button class="btn default-btn cancel " type="submit " @click.prevent="cancleAddRoomInfo">
                  Cancel
                </button>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>